export default __webpack_public_path__ + "static/media/alof.18b74980.mp3";